import * as Sentry from "@sentry/angular";
import { environment } from "../../environments/environment";

export function initSentry(): void {
  if (!environment.sentryDsn) return;

  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? "production" : "development",
    tracesSampleRate: 0.1,
    enableLogs: true,
    integrations: [Sentry.browserTracingIntegration()],
    dataCollection: {
      cookies: false,
      httpHeaders: {
        request: { deny: ["authorization"] },
        response: { deny: ["set-cookie"] }
      }
    }
  });
}
